import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import { installGuards } from './guards'

const routes: RouteRecordRaw[] = [
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/LoginView.vue'),
        meta: { requiresAuth: false }
    },
    {
        path: '/',
        name: 'dashboard',
        component: () => import('@/views/DashboardView.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/events',
        name: 'events',
        component: () => import('@/views/EventsView.vue'),
        meta: { requiresAuth: true, requiredRight: 'allowManageEvents' }
    },
    {
        path: '/ticketsets',
        name: 'ticketsets',
        component: () => import('@/views/TicketsetsView.vue'),
        meta: { requiresAuth: true, requiredRight: 'allowManageTicketsets' }
    },
    {
        path: '/tickets',
        name: 'tickets',
        component: () => import('@/views/TicketsView.vue'),
        meta: { requiresAuth: true, requiredRight: 'allowManageTickets' }
    },
    {
        path: '/tickets/import',
        name: 'tickets-import',
        component: () => import('@/views/TicketsImportView.vue'),
        meta: { requiresAuth: true, requiredRight: 'allowManageTickets' }
    },
    {
        path: '/tickets/verify',
        name: 'tickets-verify',
        component: () => import('@/views/TicketVerifyView.vue'),
        meta: { requiresAuth: true, requiredRight: 'allowManageTickets' }
    },
    {
        path: '/zones',
        name: 'zones',
        component: () => import('@/views/ZonesView.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/devices',
        name: 'devices',
        component: () => import('@/views/DevicesView.vue'),
        meta: { requiresAuth: true, requiredRight: 'allowManageDevices' }
    },
    {
        path: '/statistics',
        name: 'statistics',
        component: () => import('@/views/StatisticsView.vue'),
        meta: { requiresAuth: true, requiredRight: 'allowStats' }
    },
    {
        path: '/users',
        name: 'users',
        component: () => import('@/views/UsersView.vue'),
        meta: { requiresAuth: true, requiredRight: 'allowManageUsers' }
    },
    {
        path: '/clipboard',
        name: 'clipboard',
        component: () => import('@/views/ClipboardView.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/help',
        name: 'help',
        component: () => import('@/views/HelpView.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'not-found',
        component: () => import('@/views/NotFoundView.vue'),
        meta: { requiresAuth: true }
    }
]

// Vite's BASE_URL points at the static asset path (/static/bzuco_guard/admin-next/);
// the router base must match the URL the app is actually served from on Django (/admin-next/).
const APP_BASE = import.meta.env.VITE_APP_BASE || '/'

const router = createRouter({
    history: createWebHistory(APP_BASE),
    routes
})

installGuards(router)

export default router
